import { PickersLayout } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FormInputProps } from './InputInterface';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { format } from 'date-fns';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const DabaduDatePicker = styled(FormControl)`
  &.MuiFormControl-root {
    width: 100%;
  }
  & .MuiInputBase-input {
    font-family: ${(props) => props.theme.fonts.primary};
    color: ${(props) => props.theme.colors.textColor};
    height: auto;
    padding: 18px 20px;

    @media (max-width: 1650px) {
      padding: 12px 14px;
    }
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.colors.inputBorder};
  }
  & .MuiOutlinedInput-root {
    &:hover,
    &:active {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
  }
  & .MuiButtonBase-root {
    &:focus {
      outline: none;
    }
  }
`;

export const DateCalendarInput = ({
  name,
  control,
  label,
  rules,
  triggerValidationForField,
  minDate,
  maxDate,
  disableFuture,
}: FormInputProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DabaduDatePicker required={Boolean(rules)} error={Boolean(rules)}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange }, formState: { errors } }) => (
            <>
              {label && <label className='control-label'>{label}</label>}
              <DateCalendar
                disableFuture={disableFuture}
                // value={new Date(value)}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(val) => {
                  console.log('val', dayjs(val).format('YYYY-MM-DD'));
                  onChange(dayjs(val).format('YYYY-MM-DD'));
                  triggerValidationForField(name);
                }}
                // slots={{
                //   layout: StyledPickersLayout,
                // }}
                // slotProps={{
                //   field: { clearable: true, onClear: () => {} },
                // }}
                // format='MM/dd/yyyy'
              />
              {errors?.[name] && <FormHelperText>{errors?.[name]?.message}</FormHelperText>}
            </>
          )}
        />
      </DabaduDatePicker>
    </LocalizationProvider>
  );
};
